import { useState, useEffect } from "@wordpress/element";

export function Component({ video_id, src }) {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePlay = () => {
    if (video_id) {
      setClicked(true);
      setLoading(true);
    }
  };

  return (
    <div
      className={["relative pb-16/9", video_id && "cursor-pointer"]
        .filter(Boolean)
        .join(" ")}
      onClick={handlePlay}
    >
      {clicked && (
        <iframe
          className={["absolute inset-0 w-full h-full", loading && "opacity-0"]
            .filter(Boolean)
            .join(" ")}
          onLoad={() => setLoading(false)}
          allowFullScreen
          src={`https://www.youtube.com/embed/${video_id}?autoplay=1&hd=1&showrel=0&fs=1`}
        ></iframe>
      )}
      {!clicked && (
        <>
          <img
            className="absolute h-full w-full object-cover"
            src={src}
            alt=""
          />
          {video_id && (
            <div className="absolute inset-0 flex justify-center group items-center text-white bg-blue-900 bg-opacity-50">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-12 h-12 transition-transform duration-150 transform group-hover:scale-110"
                viewBox="0 0 56 56"
              >
                <g fill="none" fillRule="evenodd" opacity=".94">
                  <g fill="currentColor">
                    <g>
                      <path
                        d="M28 0c15.464 0 28 12.536 28 28S43.464 56 28 56 0 43.464 0 28 12.536 0 28 0zm-5.6 16.8v22.4L39.2 28 22.4 16.8z"
                        transform="translate(-160 -1264) translate(160 1264)"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export const selector = ".video-component";
